import { combineReducers } from 'redux';
import { reducer as formReducer } from 'redux-form';
import { reducers as providerReferralReducers } from '@td/provider_referral';
import { reducers as benefits } from 'medication_service_ui/dist/benefits';
import { reducers as settings } from 'medication_service_ui/dist/settings';

import {
  MedicationHistoryReducer as medicationHistory,
  FormularyReducer as formulary,
  PrescriptionBenefitsReducer as prescriptionBenefits,
  PayerSelectorReducer as eligibility,
  PatientReducer as patient,
  DrugInteractionReducer as drugInteraction,
  PrescriptionReducer as prescription,
  ProviderOrderReducer as providerOrder,
  NotificationReducer as notifications,
  PendingPrescriptionsReducer as pendingPrescriptions,
  ClinicalAllergyReducer as clinicalAllergies
} from 'medication_service_ui';
import rteTestReducers from '../RteTestComponent/reducers';
import rteEditPayerReducer from '../EditPayer/reducers';
import { reducer as clinicalMedications } from '../clinical-medication/reducers';
import { reducer as providerIncentiveCost } from '../provider-incentive/provider-incentive-cost/reducers';
import providerSurgeIncentive from '../provider-incentive/provider-surge-incentive/reducers';
import { reducer as providerSearch } from '../provider-search/reducer';
import { egrReducer, egrGroups, egrImport } from '../external_group_relations/reducers';
import { mcorReducer } from '../multi_contract_org_relations/reducers';
import { prescriberReducer } from '../surescripts-information/reducer';
import { reducer as emr } from '@td/emr'
import { conferenceReducer } from '../Conference';
import { emrManagerReducer } from '../GrantRevokeEmrManagerRole/redux/emr-manager-reducer';

export const rootReducer = combineReducers({
  rteTest: rteTestReducers,
  form: formReducer,
  providerReferral: providerReferralReducers,
  clinicalMedications,
  medicationHistory,
  benefits,
  settings,
  patient,
  formulary,
  prescriptionBenefits,
  eligibility,
  prescription,
  drugInteraction,
  providerOrder,
  notifications,
  pendingPrescriptions,
  clinicalAllergies,
  providerIncentiveCost,
  providerSurgeIncentive,
  providerSearch,
  egrReducer,
  egrGroups,
  egrImport,
  mcorReducer,
  rteEditPayer: rteEditPayerReducer,
  emr,
  conference: conferenceReducer,
  prescriberReducer,
  emrManagerReducer
});

export default rootReducer;
